export const REROLL_COOLDOWN_MS = 12 * 60 * 60 * 1000;

// The reroll cooldown is anchored to `cooldownStartedAt` on the persisted run
// state (set once when the run reaches the results screen — see useGameState),
// so it survives refreshes and resets cleanly on a new run. This module just
// formats the remaining time.
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  return [hours, minutes, seconds]
    .map((n) => String(n).padStart(2, "0"))
    .join(":");
}
